/**
 * External dependencies
 */
import {
	DesignPanelBody, ColumnControl,IconControl, ColorSettings, IconDisplay, ImageControl, BackgroundSettings, ImageUploadPlaceholder
} from '~cartzillagb/components'
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { getBootstrapClasses, range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */

import ImageDesignBasic from './images/basic.png'
import ImageDesignPlain from './images/plain.png'

/**
 * WordPress dependencies
 */
import {
	PanelBody, ToggleControl, RangeControl, BaseControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.icon-blocks.edit.inspector.style.before', 'cartzillagb/icon-blocks', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		limit,
		design,
		enableGutter,
		lgColumns,
		mdColumns,
		smColumns,
		xlColumns,
		backgroundImage,
		backgroundColor,
		background,
		titlecolor,
		desccolor,
		customtitlecolor,
		customdesccolor,
		headingcolor,
		customheadingcolor,
		iconcolor,
		enableheader,
		enableIcon
	} = attributes

	let defaultcolor =''
	let defaultheadingcolor =''
	let defaulttitlecolor =''
	let defaultdesccolor =''
	let defaulticoncolor = ''

	if ( design ==='style-1' ) {
		defaultcolor='bg-light'
		defaultheadingcolor='text-dark'
		defaulticoncolor='text-dark'
		defaultdesccolor='text-dark'

	} else if ( design ==='style-2' ){
		defaultcolor='bg-accent'
		defaulticoncolor='text-white'
		defaultheadingcolor='text-light'
		defaulttitlecolor='text-light'
		defaulttitlecolor='text-light'

	} else {
		defaultcolor='bg-dark'
		defaulticoncolor='text-primary'
		defaulttitlecolor='text-light'
		defaulttitlecolor='text-light'
	}

	return (
		<Fragment>
			<DesignPanelBody
				initialOpen={ true }
				selected={ design }
				options={ applyFilters( 'cartzillagb.icon-blocks.edit.layouts', [
					{
						label: __( 'Style - 1', i18n ), value: 'style-1', image: ImageDesignBasic,
					},
					{
						label: __( 'Style - 2', i18n ), value: 'style-2', image: ImageDesignPlain,
					},
					{
						label: __( 'Style - 3', i18n ), value: 'style-3', image: ImageDesignPlain,
					},
				] ) }
				onChange={ design => setAttributes( { design } ) }
			>
			</DesignPanelBody>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Enable header', i18n ) }
					checked={ enableheader }
					onChange={ enableheader => setAttributes( { enableheader } ) }
				/>
				{ design === 'style-1' &&
					<ToggleControl
						label={ __( 'Enable Gutter Space', i18n ) }
						checked={ enableGutter }
						onChange={ enableGutter => setAttributes( { enableGutter } ) }
					/>
				}				
				<RangeControl
					label={ __( 'Limit' ) }
					value={ limit  !== undefined ? limit : ( design ==='style-1' ? 3 : 4 ) }
					onChange={ limit => setAttributes( { limit } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.outlet-store.edit.inspector.max.limit', 12 ) }
				/>
				{ design === 'style-1' &&
					<ColumnControl
						label={ __("Cloumn Width", i18n ) }
						mdColumns={ mdColumns }
						mdMin={ 1 }
						mdMax={ 12 }
						xlColumns={ xlColumns }
						xlMin={ 1 }
						xlMax={ 12 }
						lgColumns={ lgColumns !== undefined ? lgColumns : 1 }
						lgMin={ 1 }
						lgMax={ 12 }
						onChangelg={ value => setAttributes( { lgColumns: value } ) }
						onChangemd={ value => setAttributes( { mdColumns: value } ) }
						onChangexl={ value => setAttributes( { xlColumns: value } ) }
					/>
				}
				{ design === 'style-2' &&
					<ColumnControl
						label={ __("Column Width", i18n ) }
						lgColumns={ lgColumns !== undefined ? lgColumns : 4 }
						lgMin={ 1 }
						lgMax={ 12 }
						smColumns={ smColumns }
						smMin={ 1 }
						smMax={ 12 }
						onChangesm={ value => setAttributes( { smColumns: value } ) }
						onChangelg={ value => setAttributes( { lgColumns: value } ) }
					/>
				}
				{ design === 'style-3' &&
					<ColumnControl
						label={ __("Cloumn Width", i18n ) }
						mdColumns={ mdColumns !== undefined ? mdColumns : 4 }
						mdMin={ 1 }
						mdMax={ 12 }
						smColumns={ smColumns }
						smMin={ 1 }
						smMax={ 12 }
						onChangesm={ value => setAttributes( { smColumns: value } ) }
						onChangemd={ value => setAttributes( { mdColumns: value } ) }
					/>
				}

				<ToggleControl
					label={ __( 'Display Icon', i18n ) }
					checked={ enableIcon }
					onChange={ enableIcon => setAttributes( { enableIcon } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Background Settings", i18n ) } initialOpen={ true }>
				<Fragment>
					{ design === 'style-2' &&
						<ImageControl
							imageURL={ backgroundImage }
							onChange={ ( { url } ) => setAttributes( { backgroundImage: url } ) }
							onRemove={ () => { setAttributes( { backgroundImage: '' } ) } }
						/>
					}
					<BackgroundSettings
						background={ background || defaultcolor }
						backgroundColor={ backgroundColor }
						onChangeBackground={ background => setAttributes( { background, backgroundColor: '' } ) }
						onChangeBackgroundColor={ backgroundColor => setAttributes( { backgroundColor:backgroundColor.hex, background: '' } ) }
						onRemoveBackground={ () => { setAttributes( { background: '', backgroundColor: '' } ) } }
					/>
				</Fragment>
			</PanelBody>
			<Fragment>
				<PanelBody title={ __( 'Color Settings', i18n ) } initialOpen={ false }>
					<Fragment>
						{ design !== 'style-3' &&
							<BaseControl label={ __( 'Heading color', i18n ) } id={ "color-3" } >
								<ColorSettings
									textColor={ headingcolor || defaultheadingcolor }
									textcustomColor={ customheadingcolor }
									onChangetextColor={ headingcolor => setAttributes( { headingcolor } ) }
									onChangecustomColor={ customheadingcolor => setAttributes( { customheadingcolor:customheadingcolor.hex, headingcolor:'' } ) }
									onRemovetextColor={ () => { setAttributes( { headingcolor: '', customheadingcolor: '' } ) } }
								>
								</ColorSettings>
							</BaseControl>
						}
						{ design !== 'style-1' &&
							<BaseControl label={ __( 'Title color', i18n ) } id={ "color-1" } >
								<ColorSettings
									textColor={ titlecolor || defaulttitlecolor}
									textcustomColor={ customtitlecolor }
									onChangetextColor={ titlecolor => setAttributes( { titlecolor } ) }
									onChangecustomColor={ customtitlecolor => setAttributes( { customtitlecolor:customtitlecolor.hex, titlecolor:'' } ) }
									onRemoveBackground={ () => { setAttributes( { titlecolor: '', customtitlecolor: '' } ) } }
									>
								</ColorSettings>
							</BaseControl>
						}
						{ enableIcon && 
							<BaseControl label={ __( 'Icon color', i18n ) } id={ "color-2" } >
								<ColorSettings
									textColor={ iconcolor || defaulticoncolor }
									onChangetextColor={ iconcolor => setAttributes( { iconcolor } ) }
									onRemovetextColor={ () => { setAttributes( { iconcolor: '' } ) } }
								>
								</ColorSettings>
							</BaseControl>
						}
						<BaseControl label={ __( 'Description color', i18n ) } id={ "color-2" } >
							<ColorSettings
								textColor={ desccolor || defaultdesccolor }
								textcustomColor={ customdesccolor }
								onChangetextColor={ desccolor => setAttributes( { desccolor } ) }
								onChangecustomColor={ customdesccolor => setAttributes( { customdesccolor:customdesccolor.hex, desccolor:'' } ) }
								onRemovetextColor={ () => { setAttributes( { desccolor: '', customdesccolor: '' } ) } }
							>
							</ColorSettings>
						</BaseControl>
					</Fragment>
				</PanelBody>
			</Fragment>
			{ enableIcon && 
				<PanelBody title={ __( 'Icon Settings', i18n ) } initialOpen={ true }>
					<div className="icon-control-componet-wrapper">
						{ range( 1, limit  !== undefined ? limit : ( design ==='style-1' ? 3 : 4 ) + 1 ).map( i => {

							let defaulticon = ''

							if (design === 'style-1') {

								if ( (i % 3 ) === 1 ) {
									defaulticon='fas fa-shopping-cart' 
								}

								if ( (i % 3 ) === 2 ) {               
									defaulticon='czi-bag' 
								}

								if ( (i % 3 ) === 0 ) {               
									defaulticon='fas fa-shuttle-van' 
								}
							}


							if (design === 'style-2') {

								if ( (i % 4 ) === 1 ) {
									defaulticon='fas fa-check' 
								}

								if ( (i % 4 ) === 2 ) {               
									defaulticon='fas fa-headset'
								}

								if ( (i % 4 ) === 3 ) {               
									defaulticon='fas fa-lock'
								}

								if ( (i % 4 ) === 0 ) {               
									defaulticon='fas fa-random'
								}
							}

							if (design === 'style-3') {

								if ( (i % 4 ) === 1 ) {
									defaulticon='czi-rocket' 
								}

								if ( (i % 4 ) === 2 ) {               
									defaulticon='czi-currency-exchange'
								}

								if ( (i % 4 ) === 3 ) {               
									defaulticon='czi-support'
								}

								if ( (i % 4 ) === 0 ) {               
									defaulticon='czi-card'
								}
							}

							const Icon = attributes[ `icon${ i }` ]
								return (
									<IconControl
										key={ i }
										label={ __( `Icon #${ i }`, i18n ) }
										value={ Icon || defaulticon }
										onChange={ Icon => setAttributes( { [ `icon${ i }` ]: Icon } ) }
									/>
								)
						} ) }
					</div>
				</PanelBody>
			}
			</Fragment>
	)
} )

const edit = props => {
	const {
		setAttributes, className, attributes,
	} = props

	const {
		design,
		enableContainer,
		limit,
		lgColumns,
		mdColumns,
		smColumns,
		xlColumns,
		enableGutter,
		heading,
		backgroundImage,
		backgroundColor,
		background,
		titlecolor,
		desccolor,
		customtitlecolor,
		customdesccolor,
		headingcolor,
		customheadingcolor,
		customiconcolor,
		iconcolor,
		enableheader,
		enableIcon

	} = attributes

	const mainClasses = classnames( [
		className,
		'icon-block',
		( design ==='style-2' && background !== undefined ) ? background : ( design ==='style-2' && 'bg-accent' ),
		( design ==='style-3' && background !== undefined ) ? background : ( design ==='style-3' && 'bg-darker' ),
	], applyFilters( 'cartzillagb.icon-blocks.main-block.classes', {
		'pt-4 mb-5': design === 'style-1',
		'bg-size-cover bg-position-center pt-5 pb-4 pb-lg-5' : design === 'style-2',
		'pt-5': design === 'style-3',
	}, props ) )

	const containerClasses = classnames( [], {
		'container': enableContainer,
		'pt-lg-3': design === 'style-2',
	} ) 

	const rowClasses = classnames( [
		'row',
		( design==='style-1' &&  background !== undefined ) ? background : ( design==='style-1' && 'bg-light' ),
		], {
		'no-gutters':( enableGutter === false && design === 'style-1' ),
		'rounded-lg': design === 'style-1',
		'pt-lg-2 text-center': design === 'style-2',
	} )

	const limitvalue =limit  !== undefined ? limit : ( design ==='style-1' ? 3 : 4 )

	let defaultheading = ''
	let defaultheadingcolor = ''
	let imageClasses ='' 

		if (design === 'style-1') {
			defaultheading='How it works?'
			defaultheadingcolor='text-dark'
		}
		if (design === 'style-2') {
			defaultheading='Why our marketplace?'
			defaultheadingcolor='text-light'
		}
		if (design === 'style-3') {
			defaultheading='Why our marketplace?'
			defaultheadingcolor='text-light'
		}

	const headingComp = (
		<RichText
			tagName='h2'
			className={ `h3 text-center  ${ headingcolor ? headingcolor : customheadingcolor ? '' : defaultheadingcolor } ${ design ==='style-1' ? 'mb-grid-gutter pt-2' : 'mb-3 pb-4'}` }
			value={ heading || defaultheading }
			style={ { color: customheadingcolor } }
			onChange={ heading => setAttributes( { heading } ) }
			placeholder={ __( 'heading' ) }
			keepPlaceholderOnFocus
		/>
	)

	const htmlAttr = {}

	if( ( backgroundImage || backgroundColor ) && design === 'style-2' ) {
		htmlAttr.style = {
			backgroundImage: "url(" + ( backgroundImage ) + ")",
			backgroundColor: backgroundColor && backgroundColor,

		}
	}

	const styleAttr = {}

	if( backgroundColor && design === 'style-1' ) {
		styleAttr.style = {
			backgroundColor: backgroundColor && backgroundColor,
		}
	}

	if ( design === 'style-1' ) {
		imageClasses = 'd-block my-2';
	} else {
		imageClasses = 'image';
	}

	const content = range( 1, ( limitvalue ) + 1 ).map( i => {

		const title = attributes[ `title${ i }` ]
		const desc = attributes[ `desc${ i }` ]
		const Icon = attributes[ `icon${ i }` ]
		const mediaURL = attributes[ `mediaURL${ i }` ]

		let defaulttitle =''
		let defaultdesc =''
		let defaulticon =''
		let defaulticonclass = ''

		if (design === 'style-1') {
			defaulticonclass = `d-block my-2 font-size-72 ${ iconcolor ? iconcolor : customiconcolor ? '' : 'text-dark' }`
			if ( (i % 3 ) === 1 ) {
				defaulttitle = "01"
				defaultdesc = "You order your favorite products online"
				defaulticon='fas fa-shopping-cart' 
			}

			if ( (i % 3 ) === 2 ) {               
				defaulttitle = "02"
				defaultdesc = "A personal assistant collects the products from your list"
				defaulticon='czi-bag' 
			}

			if ( (i % 3 ) === 0 ) {               
				defaulttitle = "03"
				defaultdesc = "We deliver to the door at a time convenient for you"
				defaulticon='fas fa-shuttle-van' 
			}
		}

		if (design === 'style-2') {
			defaulticonclass = `font-size-52 ${ iconcolor ? iconcolor : customiconcolor ? '' : 'text-white' }`

			if ( (i % 4 ) === 1 ) {
				defaulttitle = "Quality Guarantee"
				defaultdesc = "Quality checked by our team"
				defaulticon='fas fa-check' 
			}

			if ( (i % 4 ) === 2 ) {               
				defaulttitle = "Customer Support"
				defaultdesc = "Friendly 24/7 customer support"
				defaulticon='fas fa-headset'
			}

			if ( (i % 4 ) === 3 ) {               
				defaulttitle = "Lifetime Free Updates"
				defaultdesc = "Never pay for an update"
				defaulticon='fas fa-lock'
			}

			if ( (i % 4 ) === 0 ) {               
				defaulttitle = "Secure Payments"
				defaultdesc = "we posess SSL / Secure сertificate"
				defaulticon='fas fa-random'
			}
		}

		if (design === 'style-3') {
			defaulticonclass = `font-size-36 ${ iconcolor ? iconcolor : customiconcolor ? '' : 'text-primary' }`

			if ( (i % 4 ) === 1 ) {
				defaulttitle = "Fast and free delivery"
				defaultdesc = "Free delivery for all orders over $200"
				defaulticon='czi-rocket' 
			}

			if ( (i % 4 ) === 2 ) {               
				defaulttitle = "Money back guarantee"
				defaultdesc = "We return money within 30 days"
				defaulticon='czi-currency-exchange'
			}

			if ( (i % 4 ) === 3 ) {               
				defaulttitle = "24/7 customer support"
				defaultdesc = "Friendly 24/7 customer support"
				defaulticon='czi-support'
			}

			if ( (i % 4 ) === 0 ) {               
				defaulttitle = "Secure online payment"
				defaultdesc = "We possess SSL / Secure сertificate"
				defaulticon='czi-card'
			}
		}

		const iconComp = (
			<IconDisplay 
				value={ Icon || defaulticon }
				additionalClass={ defaulticonclass }
			/>    
		)

		const imageComp = (
			<ImageUploadPlaceholder
				imageURL={ mediaURL }
				onRemove={ () => {
					setAttributes( {
						[ `mediaURL${ i }` ]: '',
					} )
				} }
				onChange={ ( { url } ) => {
					setAttributes( {
						[ `mediaURL${ i }` ]: url,
					} )
				} }
				hasRemove={ false }
				render={ <img src={ mediaURL } className= { imageClasses } width={ design === 'style-1' ? '72' : '52' } alt={ __( 'Image', i18n ) } /> }
			/>
		)

		let titleClass= ''

		if ( design === 'style-1' ) {
			titleClass = 'display-2 font-weight-normal border-color mr-4 text-nowrap'
		} else {
			titleClass = `font-size-base mb-1 ${ titlecolor ? titlecolor : customtitlecolor ? '' : 'text-light' }`
		}

		let descClass= ''

		if ( design === 'style-1' ) {
			descClass = `mb-3 pt-1 ${ desccolor ? desccolor : customdesccolor ? '' : 'text-dark' }`
		} else if ( design === 'style-2' ) {
			descClass =`font-size-ms opacity-70 mb-0 ${ desccolor ? desccolor : customdesccolor ? '' : 'text-light' }`
		} else {
			descClass=`mb-0 font-size-ms opacity-50 ${ desccolor ? desccolor : customdesccolor ? '' : 'text-light' }`
		}


		const titleComp = (
			<RichText
				tagName={ design === 'style-1' ? 'div' : 'h6' }
				className={ titleClass }
				style={ { color: customtitlecolor } }
				value={ title || defaulttitle }
				onChange={ title => setAttributes( { [ `title${ i }` ]: title } ) }
				placeholder={ __( 'Title' ) }
				keepPlaceholderOnFocus
			/>
		)

		const descComp = (
			<RichText
				tagName='p'
				className={ descClass }
				style={ { color: customdesccolor } }
				value={ desc || defaultdesc }
				onChange={ desc => setAttributes( { [ `desc${ i }` ]: desc } ) }
				placeholder={ __( 'Description' ) }
				keepPlaceholderOnFocus
			/>
		)

		const bootstrapClass = getBootstrapClasses( undefined, undefined, mdColumns !== undefined ? mdColumns : 3, lgColumns !== undefined ? lgColumns : 1, xlColumns )

		const bootstrapClass2 = getBootstrapClasses( undefined, smColumns, undefined, lgColumns !== undefined ? lgColumns : 4, undefined )

		const bootstrapClass3 = getBootstrapClasses( undefined, smColumns, mdColumns !== undefined ? mdColumns : 4, undefined )

		let style = ''

		if ( design === 'style-1' ) {
			style = (
				<div className={ classnames( [ `${ bootstrapClass } ${ i !== (limitvalue ) ? 'border-right' : ''}` ] ) } >
					<div className="py-3">
						<div className="d-flex align-items-center mx-auto py-3 px-3 mw-22">
							{ titleComp }
							<div className="pl-2">
							{ enableIcon && 
								iconComp
							}

							{ ! enableIcon && 
								imageComp
							}
								{ descComp }
							</div>
						</div>
						<hr className="d-md-none d-lg-block d-xl-none" />
					</div>
				</div>
			)
		}

		if ( design === 'style-2' ) {
			style = (
				<div className={ `${ bootstrapClass2 } mb-grid-gutter` }  key={ i }>
					<div className="d-inline-block">
						<div className="media media-ie-fix align-items-center text-left">
							{ enableIcon && 
								iconComp
							}

							{ ! enableIcon && 
								imageComp
							}
							<div className="media-body pl-3">
								{ titleComp }
								{ descComp }
							</div>
						</div>
					</div>
				</div>
			)
		}

		if ( design === 'style-3' ) {
			style = (
				<div className={ `${ bootstrapClass3 } mb-4` }  key={ i }>
					<div className="media">
						{ enableIcon && 
							iconComp
						}

						{ ! enableIcon && 
							imageComp
						}
						<div className="media-body pl-3">
							{ titleComp }
							{ descComp }
						</div>
					</div>
				</div>
			)
		}

		return style
	} )
		

	return (
		<Fragment>
			{ design !== 'style-3' &&
				<section className={ mainClasses } { ...htmlAttr }>
					<div className={ containerClasses }>
						<Fragment>
							{ enableheader &&
								headingComp
							}
							<div className={ rowClasses } { ...styleAttr }>
								{ content }
							</div>
						</Fragment>
					</div>
				</section>
			}
			{ design === 'style-3' &&
				<div className={ mainClasses }>
					<div className={ containerClasses }>
						{ enableheader &&
							headingComp
						}
						<div className="row pb-3">
							{ content }
						</div>
					</div>
				</div>
			}
		</Fragment>
	)  
}

export default compose(
	withTabbedInspector( [ 'style','advanced' ] ),
)( edit )